import { withStyles } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { AutocompleteClassKey } from '@material-ui/lab';
import * as React from 'react';
import { DSAutocomplete } from './Autocomplete';

export const AutocompleteBold: typeof DSAutocomplete = withStyles<
    Extract<AutocompleteClassKey, 'input' | 'inputRoot' | 'popupIndicator' | 'popupIndicatorOpen'>
>(theme => ({
    input: {
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightBold as number,
        padding: theme.spacing(0.7, 0, 1.4),
    },
    inputRoot: {
        '&:after': {
            borderBottomColor: theme.palette.secondary.main,
        },
        '&:before': {
            borderBottomColor: theme.palette.primary.main,
            borderBottomWidth: 2,
        },
        '&:hover': {
            '&:before': {
                borderBottomColor: `${theme.palette.secondary.main} !important`,
            },
        },
    },
    popupIndicator: {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(24),
    },
    popupIndicatorOpen: {
        color: theme.palette.secondary.main,
    },
}))((props: Parameters<typeof DSAutocomplete>[0]) => (
    <DSAutocomplete {...props} popupIcon={<KeyboardArrowDownIcon />} />
)) as typeof DSAutocomplete;
